import { h } from './index-d3a9c8bd.js';
import { c as clsx } from './clsx-1afe6a70.js';
import { A as ARIA } from './constants-93a27459.js';

const InternalNesCheckboxInput = ({ id, name, value, checked, disabled, required, isIndeterminate, tabIndex, helpText, label, passive, hiddenLabel, loading, border, error, padding, width, onClick, dataAttributes, reference, }) => (h("div", { class: clsx('nes-checkbox', {
        'nes-checkbox--checked': checked,
        'nes-checkbox--disabled': disabled,
        'nes-checkbox--indeterminate': isIndeterminate && !checked,
        'nes-checkbox--is-loading': loading,
        'nes-checkbox--padding': padding,
        'nes-checkbox--borderless': !border,
        'nes-w-full': width === 'full',
    }), onClick: onClick },
    h("div", { class: clsx('nes-checkbox__input-holder', {
            'nes-checkbox__input-holder--checked': checked,
            'nes-checkbox__input-holder--indeterminate': isIndeterminate,
            'nes-checkbox__input-holder--borderless': !border,
            'nes-checkbox__input-holder--error': error,
        }), "data-test-id": "nes-checkbox-input-holder" },
        h("div", { class: clsx('nes-checkbox__icon', {
                'is-active': checked,
            }) },
            h("nes-icon", { color: "text-light", name: "check-thick", "nes-aria-hidden": "true" })),
        h("div", { class: clsx('nes-checkbox__icon', 'nes-checkbox__icon--indeterminate', {
                'is-active': isIndeterminate && !checked,
            }) },
            h("div", { class: "nes-checkbox__iconIndeterminate" })),
        h("input", { class: "nes-checkbox__input", type: "checkbox", id: id, name: name, value: value, checked: checked, disabled: disabled, required: required, "aria-describedby": helpText ? ARIA.helpText : null, tabIndex: tabIndex ? tabIndex : undefined, "data-nes": dataAttributes, ref: reference ? (el) => reference(el) : undefined })),
    h("div", { class: "nes-checkbox__text" },
        h("label", { htmlFor: id, class: clsx('nes-checkbox__label', {
                'nes-sr-only': hiddenLabel,
                'nes-pointer-events-none': passive,
            }) }, label),
        helpText && (h("div", { class: "nes-checkbox__help-text" },
            h("nes-help-text", { id: ARIA.helpText }, helpText))))));

export { InternalNesCheckboxInput as I };
